import { render, staticRenderFns } from "./novel_generator.vue?vue&type=template&id=2fad7750"
import script from "./novel_generator.vue?vue&type=script&lang=js"
export * from "./novel_generator.vue?vue&type=script&lang=js"
import style0 from "./novel_generator.vue?vue&type=style&index=0&id=2fad7750&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports